export default __webpack_public_path__ + "static/media/undraw_vintage_q09n.5567e12e.svg";